import { ViewableRequest } from '../review-request/review-request.model';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { Component, OnInit } from '@angular/core';
import { RequestStatusEnum } from '../../shared/services/request-status.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Sources, RequestCommentSubmission } from '../../shared/services/request-comments.service';

@Component({
  selector: 'app-request-rejection-modal',
  templateUrl: './request-rejection-modal.component.html',
  styleUrls: ['./request-rejection-modal.component.css']
})
export class RequestRejectionModalComponent implements OnInit {
  public request: ViewableRequest;
  public rejectionForm: FormGroup;
  public get comment() { return this.rejectionForm.get("comment") };

  public onClose: Subject<any> = new Subject<any>();
  public onRejected: Subject<RequestCommentSubmission> = new Subject<RequestCommentSubmission>();
  public onBackToPlanning: Subject<RequestCommentSubmission> = new Subject<RequestCommentSubmission>();

  public submittedOrAssigned: boolean = false;
  public readyForReview: boolean = false;

  constructor(private modalRef: BsModalRef, formBuilder: FormBuilder) { 
    this.rejectionForm = formBuilder.group({
      comment: formBuilder.control(null)
    });
  }

  ngOnInit(): void {
    this.submittedOrAssigned = this.request.statusId === RequestStatusEnum.Submitted || this.request.statusId === RequestStatusEnum.Assigned;
    this.readyForReview = this.request.statusId === RequestStatusEnum.ReadyForReview ? true : false;
  }

  public backToDraft(): void {
    this.onRejected.next(
      {
        requestId: this.request.id,
        comment: this.comment.value,
        source: this.rejectionSource()
      }
    );
  }

  public backToPlanning(): void {
    this.onBackToPlanning.next({
      requestId: this.request.id,
      comment: this.comment.value,
      source: Sources.rejectionFromPlannedToPlanning
    });
  }

  public closeModal(): void {
    this.modalRef.hide();
  }

  private rejectionSource(): string {
    switch (this.request.statusId) {
      case RequestStatusEnum.Submitted: return Sources.rejectionFromSubmitted;
      case RequestStatusEnum.Assigned: return Sources.rejectionFromAssigned;
      case RequestStatusEnum.ReadyForReview: return Sources.rejectionFromPlannedToDraft;
      default: return "ERROR: Status not found";
    }
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-rejection-modal/request-rejection-modal.component.ts